import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, ButtonGroup, Checkbox, CircularProgress, FormControlLabel, Modal, Radio, RadioGroup, styled, Switch } from "@mui/material";
import cn from "classnames";
import _ from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaCheck, FaFileUpload } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useSelector } from "react-redux";
import { useChangeRoleMutation } from "../../../../api/admins";
import {
  useApproveDriverMutation,
  useBackgroundCheckMutation,
  useCreateOrUpdateCustomerMutation,
  useCreateOrUpdateFundingSourceMutation,
  useGetDriverQuery,
  useLazyGetDebugInsuranceImgQuery,
  useLazyGetDebugLicenceImgQuery,
  useLazyGetProfilePhotoQuery,
  useLazyGetSignedOAIUrlQuery,
  useLazyRefreshDriverBranchQuery,
  useRemoveUnderReviewMutation,
  useStatusUnderReviewMutation,
  useSuspendDriverMutation,
  useUnderReviewMutation,
  useUpdateDriverMutation,
  useWaitListDriverMutation,
} from "../../../../api/drivers";
import { useGetReasonsQuery } from "../../../../api/reason";
import {
  checkForError,
  sendErrorMessage,
} from "../../../../constants/extras/errorHandlers";
import { sendSuccessMessage } from "../../../../constants/extras/sendSuccessMsg";
import { handleBackgroundStatusesBadge } from "../../../../constants/extras/statusesBadge";
import emptyImg from '../../../../images/empty-image.png';
import warningIconYlow from "../../../../images/yellow-warning.svg";
import { actions } from "../../../../redux/store/store";
import { uploadFile } from "../../../../util/fetch";
import SwitchRoleConfirmation from "../../../common/SwitchRoleConfirmation";
import { maskingInfo } from "../../../shared/helper/index";
import Time from "../../DaySchedule";
import { ErrorMessage, InputItem } from "../../Form";
import SuspensionForm from "../../SuspensionForm";
import ConfirmDialogModal from "../confirmDialog";
import "../style.scss";
import History from "./History";
import ImagePreviewModal from "./ImagePreviewModal";
import RotatableImage from "./RotatableImage";
import EditCompany from "./editCompany";
import EditDriverLicense from "./editDriverLicense";
import EditInsuracePolicy from "./editInsurancePolicy";
import EditMetro from "./editMetro";
import EditNotes from "./editNotes";
import EditOAIInsurance from "./editOAI";
import EditPhone from "./editPhone";
import EditSchedule from "./editSchedule";
import EditVehicle from "./editVehicle";
import fields from "./fields";
import { generateImageInfo } from "./imageInfoUtils";
import "./style.driver.scss";
import Terms from "./term";
import EditDeleteSignature from "./editDeleteSignature";
import ClearIcon from "@mui/icons-material/Clear";
import { useDocumentApprovalMutation } from "../../../../api/rejectedDocumentReason";
import { driveDocumentType } from "../../../../constants/menuLists";
import { PAGINATION } from "../../../../constants/variables";
import { getTransactionsList } from "../../../../api/reports";
import ResetDocumentStatus from "./resetDocumentStatus";

const aprroveReasonList = [{
  lable: "Allow driver to take shifts",
  value: "Approve"
}, {
  lable: "keep driver in the wait list",
  value: "waiting"
}];

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 6,
  '& .MuiSwitch-switchBase': {
    transitionDuration: '500ms',
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 20,
    height: 20,
    margin: 0,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#ccd7dd' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 1000,
    }),
  },
}));

// const emptyImg =
//   "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
};

const previewBtnStyle = { padding: '0 8px', fontSize: '14px', border: 'none', borderRadius: '4px', backgroundColor: '#4195f5', color: '#fff', height: '32px', marginTop: '-22px' }

const CustomModal = ({ id }) => {
  const { data: driver, isLoading: driverLoading, refetch } = useGetDriverQuery(id, {
    refetchOnMountOrArgChange: true,
    skip: !id,
  });
  const [update, updateReq] = useUpdateDriverMutation();
  const [createOrUpdateCustomer, createOrUpdateCustomerReq] =
    useCreateOrUpdateCustomerMutation();
  const [createOrUpdateFundingSource, createOrUpdateFundingSourceReq] =
    useCreateOrUpdateFundingSourceMutation();
  const [approveDriver, approveDriverReq] = useApproveDriverMutation();
  const [waitingListDriver, waitingListDriverReq] = useWaitListDriverMutation();
  const [backgroundCheck] = useBackgroundCheckMutation();

  const [getDebugLicenceApi, { isFetching: debugLicenceLoading }] = useLazyGetDebugLicenceImgQuery()
  const [getDebugInsuranceApi, { isFetching: debugInsuranceLoading }] = useLazyGetDebugInsuranceImgQuery()
  const [getProfilePhotoApi, { isFetching: profilePhotoLoading }] = useLazyGetProfilePhotoQuery()
  const [getSignedOAIApi, { isFetching: oaiLoading }] = useLazyGetSignedOAIUrlQuery()
  const [refreshDriverBranchApi, { isFetching: rdbLoading }] = useLazyRefreshDriverBranchQuery()

  const customerForm = useForm();
  const fundingSourceForm = useForm();

  const limitMsg = "File size must be less than 10 MB"

  const [insuranceImg, setInsuranceImg] = useState(emptyImg);
  const [optionalInsuranceImg, setOptionalInsuranceImg] = useState(emptyImg);
  const [licenseFrontImg, setLicenseFrontImg] = useState(emptyImg);
  const [licenseBackImg, setLicenseBackImg] = useState(emptyImg);
  const [profileImg, setProfileImg] = useState(emptyImg);
  const [OAIInsurance, setOAIInsurance] = useState(emptyImg)
  const [switchRole, setSwitchRole] = useState([false, ""]);
  const [isImageChange, setIsImageChange] = useState("");
  const [isOptionalImageChange, setIsOptionalImageChange] = useState("");
  const [frontLoading, setFrontLoading] = useState(false)
  const [backLoading, setBackLoading] = useState(false)
  const [imgLimit, setImgLimit] = useState({
    front: false,
    back: false,
    insurance: false,
    insuranceOptional: false,
    profilePhoto: false,
    frontMsg: limitMsg,
    backMsg: limitMsg,
    insuranceMsg: limitMsg,
    insuranceOptionalMsg: limitMsg,
    profileMsg: limitMsg,
  })
  const [documentApproval, setDocumentApproval] = useState({
    licenceApproval: false,
    selfieApproval: false,
    insuranceApproval: false,
    signatureApproval: false,
  });
  const [unapproveOverride, setUnapproveOverride] = useState({
    licenceApproval: false,
    selfieApproval: false,
    insuranceApproval: false,
    signatureApproval: false,
  });
  const [selectedReason, setSelectedReason] = useState([])
  const [selectedSelfieReason, setSelectedSelfieReason] = useState([])
  const [selectedInsuranceReason, setSelectedInsuranceReason] = useState([]);
  const [selectedSignatureReason, setSelectedSignatureReason] = useState([]);
  const [showComfirmApproveModal, setShowComfirmApproveModal] = useState("")

  const currentUser = useSelector((state) => state.auth.currentUser);

  let driverData;
  if (driver !== undefined) {
    driverData = { ...driver };
  }

  const checkForRoot = currentUser && currentUser?.role === "root";
  // const checkForIsDriverBlocked = driver && driver?.isBlocked === true;
  const checkForApproveOrReject =
    driver && ["waiting", "submitted", "draft", "needs_resubmission", "resubmitted"].includes(driver?.status) && checkForRoot;
  const checkForWaitingList =
    driver && ["submitted", "draft", "needs_resubmission", "resubmitted"].includes(driver?.status) && checkForRoot;
  const checkForOffBoardDriver =
    ["approved", "inactive", "suspended"].includes(driver?.status);
  const checkForOnBoardDriver = driver?.status === "offboarded";
  const checkForMakingDriverInactive = ["approved", "suspended"].includes(driver?.status);
  const checkForActivateDrivers = ["inactive", "suspended"].includes(driver?.status);

  const fetchLicenceImg = async () => {
    setFrontLoading(true)
    setBackLoading(true)
    const data = await getDebugLicenceApi(id)

    if (!data?.error) {
      const img = new Image();
      const img1 = new Image();
      img.src = data?.data?.url?.license_front_url;
      img1.src = data?.data?.url?.license_back_url;

      img.onload = () => {
        setFrontLoading(false)
        setLicenseFrontImg(data?.data?.url?.license_front_url || emptyImg)
      };
      img1.onload = () => {
        setBackLoading(false)
        setLicenseBackImg(data?.data?.url?.license_back_url || emptyImg)
      };
    } else {
      setFrontLoading(false)
      setBackLoading(false)
    }
  }

  const fetchDebugInsuranceImg = async () => {
    setIsImageChange('file')
    setIsOptionalImageChange('optionalFile')
    const data = await getDebugInsuranceApi(id)

    if (!data?.error) {
      const img = new Image();
      const img1 = new Image();
      img.src = data?.data?.url;
      img1.src = data?.data?.optionalUrl;
      img.onload = () => {
        setIsImageChange("")
        setInsuranceImg(data?.data?.url || emptyImg)
      };
      if (data?.data?.optionalUrl) {
        img1.onload = () => {
          setIsOptionalImageChange("")
          setOptionalInsuranceImg(data?.data?.optionalUrl)
        };
      } else {
         setIsOptionalImageChange("")
         setOptionalInsuranceImg(emptyImg)
      }
    } else {
      setIsImageChange("");
      setIsOptionalImageChange("")
    }
  }

  const fetchProfilePhoto = async () => {
    setIsImageChange('profilePhoto')
    const data = await getProfilePhotoApi(id)

    if (!data?.error) {
      const img = new Image();
      img.src = data?.data?.url;
      img.onload = () => {
        setIsImageChange("")
        setProfileImg(data?.data?.url || emptyImg)
      };
    } else {
      setIsImageChange("")
    }
  }

  const fetchOAIInsurance = async () => {
    setIsImageChange('oaiPhoto')
    const data = await getSignedOAIApi(id)

    if (!data?.error) {
      const img = new Image();
      img.src = data?.data?.url;
      img.onload = () => {
        setIsImageChange("")
        setOAIInsurance(data?.data?.url || emptyImg)
      };
    } else {
      setIsImageChange("")
    }
  }

  const fileUpload = (type, url) => async (e) => {
    if (e.target.files[0] === "") return;
    e.preventDefault();
    const imageType = e.target.files[0]?.type.includes("image")
    if (e.target.files[0]?.size < 10 * 1024 * 1024 && imageType) {
      setIsImageChange(type)
      setImgLimit({ ...imgLimit, [type]: false, [`${type}Msg`]: imageType && limitMsg })
      const res = await uploadFile(`/drivers/${id}/${url}`, type == "oaiPhoto" ? "file" : type, e.target.files[0]);

      if (res?.error) {
        setIsImageChange("")
        setIsOptionalImageChange("")
        sendErrorMessage(`${res?.message}`);
      } else {
        type === "oaiPhoto" && fetchOAIInsurance();
        type === "insurance" && fetchDebugInsuranceImg();
        type === "insuranceOptional" && fetchDebugInsuranceImg();
        type === "front" && fetchLicenceImg();
        type === "back" && fetchLicenceImg();
        type === "profilePhoto" && fetchProfilePhoto();
        setIsImageChange("")
        setIsOptionalImageChange("")
        checkForUpdateStatus(type)
      }
      return res
    } else {
      setImgLimit({
        ...imgLimit, [type]: true,
        [`${type}Msg`]: imageType ? limitMsg : "Only images are allowed"
      })
    }
  };

  const [showDialog, setShowDialog] = useState(false);
  const handleDelete = async () => {
    const result = await update({
      _id: id,
      onboardingDriverOAIFillStatus: null,
      OAI: {
        isOwnOAI: null,
        img: null,
        policy_no: null,
        exp_date: null
      }
    });
    if (!result?.error) {
      sendSuccessMessage(`Insurance Policy updated successfully`);
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setShowDialog(false)
  }

  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleWaitingList = async () => {
    const result = await waitingListDriver({ _id: driver._id });
    if (!result?.error) {
      sendSuccessMessage("Driver moved to waiting list successfully");
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setShowConfirmation(false)
  }
  const [showApproveConfirmation, setShowApproveConfirmation] = useState(false);
  const [showConApproveConfirmation, setShowConApproveConfirmation] = useState(false);
  const [selecteApproveOption, setSelecteApproveOption] = useState("")
 
  const handleApproveDriver = async () => {
    if (selecteApproveOption === "Approve") {
      if (!driver?.branch || !driver?.branch?.status.includes("ACTIVE")) {
        setShowConApproveConfirmation(true);
        return;
      }
      let payload = { _id: driver._id };
      const result = await approveDriver(payload);
      await handleStatus(result, "approved");
    } else {
      await handleWaitingList();
    }
    setShowApproveConfirmation(false);
    setSelecteApproveOption("");
  };

  const handleConditionallyApproved = async () => {
    const result = await approveDriver({ _id: driver._id, isConditionallyApproved: true });
    await handleStatus(result, "approved");
    setShowConApproveConfirmation(false);
    setShowApproveConfirmation(false);
    setSelecteApproveOption("");
  }; 

  const [suspendDriverFn, { isLoading: SuspendLoading }] = useSuspendDriverMutation();
  const [suspendConfirmation, setSuspendConfirmation] = useState(false);
  const [suspensionData, setSuspensionData] = useState({
    category: '',
    group: '',
    reasonId: '',
    reasonText: '',
    severity: '',
    underReviewReason: '',
    suspensionDays: 0,
    suspensionDate: new Date()
  });
  const [reasonData, setReasonData] = useState({
    suspensionReasonData: [],
    licenseReasonData: [],
    insuranceReasonData: [],
    selfieReasonData: [],
    signatureReasonData: []
  })

  const { data: reasonApiData, isLoading: reasonLoading } = useGetReasonsQuery(['suspension', driveDocumentType.driversLicense, driveDocumentType.insurancePolicy, driveDocumentType.selfie, driveDocumentType.signature]);

  const handleSuspensionDataChange = useCallback((data) => {
    setSuspensionData(data);
  }, []);

  const handleSuspension = async () => {
    const result = await suspendDriverFn({
      id: driver._id,
      reason: suspensionData.reasonId,
      dueDate: moment(suspensionData.suspensionDate).format('MM/DD/YYYY'),
      underReviewReason: suspensionData.underReviewReason
    });
    if (!result?.error) {
      sendSuccessMessage("Driver suspended successfully");
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setSuspendConfirmation(false)
  }

  const [underReviewFn, { isLoading: murLoading }] = useUnderReviewMutation();
  const [statusUnderReviewFn, { isLoading: msurLoading }] = useStatusUnderReviewMutation();
  const [documentApprovalFn, { isLoading: docRLoading }] = useDocumentApprovalMutation();
  const [murReason, setMurReason] = useState(driver?.underReview?.reason || '');
  const [showMur, setShowMur] = useState(false);
  const [showModalOfUr, setShowModalOfUr] = useState(false);

  const handleMurSwitch = (checked) => {
    if (!checked && currentUser?.role === "root") {
      setMurdeleteConf(true)
    } else if (checked) {
      setShowMur(true)
    }
  }

  const handleUnderReview = async () => {
    const result = await underReviewFn({ id: driver._id, reason: murReason });
    if (!result?.error) {
      sendSuccessMessage("Driver marked under review successfully");
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setShowMur(false)
  }

  const handlStatuseUnderReview = async () => {
    const result = await statusUnderReviewFn({ id: driver._id });
    if (!result?.error) {
      sendSuccessMessage("Driver marked under review successfully");
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setShowModalOfUr(false);
  };

  const [murdeleteConf, setMurdeleteConf] = useState(false);
  const [removeUnderReviewFn, { isLoading: removeReviewLoading }] = useRemoveUnderReviewMutation();

  const handleImagePreview = (imageSrc, type) => {
  };

  const handleRemoveUnderReview = async () => {
    const result = await removeUnderReviewFn({ id: driver._id });
    if (!result?.error) {
      setMurReason('');
      sendSuccessMessage("Driver removed from under review successfully");
      actions.refetch.setIsDataRefetch(true);
    } else {
      checkForError(result);
    }
    setMurdeleteConf(false)
  }

  const checkForUpdateStatus = async (type) => {
    let { firstName, lastName, address, city, state, zipCode, insuranceDateExp, insurancePolicyNumber, insuranceState, driverLicenseBirthday, driverLicenseDateExp, driverLicenseNumber, driverLicenseState, driverLicenseBack, driverLicenseFront } = driverData;
    let params = {};
    if (type === 'profilePhoto' && ![firstName, lastName, address, city, state, zipCode].includes('') && driverData?.onboardingDriverBadgeFillStatus !== 'completed') {
      params.onboardingDriverBadgeFillStatus = 'completed'
    }
    if (type === 'insurance' && ![insuranceDateExp, insuranceState].includes('') && driverData?.onboardingVehicleFillStatus !== 'completed') {
      params.onboardingVehicleFillStatus = 'completed'
    }
    if (type === 'front' && ![driverLicenseBirthday, driverLicenseDateExp, driverLicenseNumber, driverLicenseState].includes('') && driverLicenseBack && driverData?.onboardingLicenceFillStatus !== 'completed') {
      params.onboardingLicenceFillStatus = 'completed'
    }
    if (Object.keys(params).length > 0) {
      await update({ _id: id, ...params });
      refreshData();
    }
  }

  const [showLicense, setShowLicense] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showOAI, setShowOAI] = useState(false)
  const [showProfile, setShowProfile] = useState(false);
  const [changeRole, { isLoading }] = useChangeRoleMutation();
  
  const [transitionHistoryData, setTransitionHistoryData] = useState(false);

  useEffect(() => {
    if (showLicense && (licenseFrontImg === emptyImg || licenseBackImg === emptyImg) && (driver?.onboardingLicenceFillStatus || !driver.isLicenseReview)) {
      fetchLicenceImg();
    }
  }, [showLicense])

  useEffect(() => {
    if (showPolicy && insuranceImg === emptyImg && driver?.onboardingVehicleFillStatus) {
      fetchDebugInsuranceImg();
    }
  }, [showPolicy])

  useEffect(() => {
    if (showProfile && profileImg === emptyImg && driver?.onboardingDriverBadgeFillStatus) {
      fetchProfilePhoto();
    }
  }, [showProfile])

  useEffect(() =>
    showOAI && OAIInsurance === emptyImg && driver?.OAI?.isOwnOAI && fetchOAIInsurance(),
    [showOAI]
  )

  useEffect(() => {
    if (driver) {
      (async () => {
        let adhocPayments = false;
        let instantPayments = false;
        let exceptionPayments = false;
        let weeklyPayments = false;
        let shiftPayments = false;
        let shift = false;
  
        const data = await getTransactionsList(
          1,
          PAGINATION.COMMON__LIMIT,
          "",
          "",
          `${driver?.firstName} ${driver?.lastName}`,
          true,
          "",
          "",
          "",
          adhocPayments,
          instantPayments,
          exceptionPayments,
          weeklyPayments,
          shiftPayments,
          shift,
          "",
          "",
          ""
        );
        if (!data?.result) return
        const filteredData = data?.result?.filter((item) => item.payment === "Referral Program" || item.payment === "adhocpayment" || item.payment === "Referral Bonus")
        const transactionWallet = filteredData.reduce(
          (sum, item) =>
            item.status === "COMPLETED"
              ? sum + Number(item.amount || 0)
              : sum,
          0
        );
        setTransitionHistoryData({
          result: filteredData,
          totalAmount: transactionWallet
        })
       })()
    }
    }, [driver])

  const classNameNormalize = (name) => {
    return name
      ? name
        .toLowerCase()
        .replaceAll(" ", "-")
        .replaceAll("/", "-")
        .replaceAll(":", "")
      : null;
  };

  if (driverData) {
    driverData.EIN = maskingInfo(driverData.EIN);
    driverData.SSN = maskingInfo(driverData.SSN);
    driverData.orginalDriverLicenseNumber = driverData?.driverLicenseNumber ? JSON.parse(JSON.stringify(driverData?.driverLicenseNumber)) : '';
    driverData.driverLicenseNumber = maskingInfo(
      driverData.driverLicenseNumber
    );
    driverData.phone = formatPhoneNumber(driverData.phone);
  }
  const BriefItem = useCallback(
    ({ width, field, title = _.startCase(field), edit }) => {
      // if (field === "onboardingDriverOAIFillStatus" && !driverData?.isOAIActive) return null;

      const output =
        field instanceof Function
          ? field(driverData)
          : _.get(driverData, field);

      return (
        <li className={`brief__item brief__item_${classNameNormalize(title)}`}>
          <span
            className="brief__item-cell brief__item-cell_title"
            style={{
              width: width ? `${width}%` : "30%",
            }}
          >
            {title}:
          </span>
          <span
            className="brief__item-cell brief__item-cell_value"
            style={{ width: "50%" }}
          >
            {(() => {
              switch (title) {
                case "Vehicle Type":
                  return (
                    <EditVehicle
                      id={id}
                      currentUser={currentUser && currentUser}
                      driver={driver}
                    />)
                case "Signature W9 Agreement":
                  return (
                    <EditDeleteSignature
                      id={id}
                      currentUser={currentUser && currentUser}
                      driver={driver}
                    />)
                case "Birthday":
                  return (
                    <EditDriverLicense
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={'Update Driver License'}
                      driverData={driverData}
                      birthday={driverData.driverLicenseBirthday}
                    />
                  );
                case "Date Expiration":
                  if (field === 'insuranceDateExp') {
                    return (
                      <EditInsuracePolicy
                        id={id}
                        currentUser={currentUser && currentUser}
                        title={'Update Insurance Policy'}
                        driverData={driverData}
                        insuranceDateExp={driverData.insuranceDateExp}
                      />
                    );
                  } else if (field === 'OAI.exp_date') {
                    return (<EditOAIInsurance
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={'Update Insurance Policy'}
                      driverData={driverData}
                      insuranceDateExp={driverData.insuranceDateExp}
                    />)
                  } else {
                    return <React.Fragment>{output}</React.Fragment>;
                  }
                case "Phone":
                  return (
                    <EditPhone
                      notes={output}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "Days":
                  return (
                    <React.Fragment>
                      {/* <Days {...driver} /> */}
                      <EditSchedule
                        driver={driver}
                        currentUser={currentUser && currentUser}
                        id={id}
                      />
                    </React.Fragment>
                  );
                case "Time":
                  return <Time {...driver} />;
                case "Last Login at":
                  return driver?.lastLoginTime
                    ? moment(driver?.lastLoginTime).format("LLL")
                    : "";
                case "Metro":
                  return (
                    <EditMetro
                      metro={output}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "Notes":
                  return (
                    <EditNotes
                      notes={driverData?.internalNote}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "Company":
                  return (
                    <EditCompany
                      company={driver?.company}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                      edit={edit}
                    />
                  );
                case "First Name":
                  return (
                    <EditNotes
                      notes={driver?.firstName}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "Last Name":
                  return (
                    <EditNotes
                      notes={driver?.lastName}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "Address":
                  return (
                    <EditNotes
                      notes={driver?.address}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "City":
                  return (
                    <EditNotes
                      notes={driver?.city}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "State":
                  return (
                    <EditCompany
                      company={output}
                      id={id}
                      currentUser={currentUser && currentUser}
                      title={title}
                      edit={edit}
                    />
                  );
                case "Zip Code":
                  return (
                    <EditNotes
                      notes={driver?.zipCode}
                      id={id}
                      state={driver}
                      currentUser={currentUser && currentUser}
                      title={title}
                    />
                  );
                case "1099 Consent":
                  return driverData?.isConsent1099 ? "Enabled" : "Disabled";
                case "Consent Time":
                  return driver?.consentTime
                    ? moment(driver?.consentTime).format("LLL")
                    : "";
                case "Selfie Status":
                  return (
                    <ResetDocumentStatus
                      title={title}
                      status={driver?.isSelfieReview ? "Approved" : selfieReaosn?.length ? "Rejected" : (!selfieReaosn?.length && driver?.onboardingDriverBadgeFillStatus && !driver?.isSelfieReview) ? "Pending" : ""}
                      driver={driver}
                      reasons={selectedSelfieReason}
                      refreshData={refreshData}
                    />
                  )
                case "License Status":
                  return (
                     <ResetDocumentStatus
                      title={title}
                      status={driver?.isLicenseReview ? "Approved" : driverReaosn?.length ? "Rejected" : (!driverReaosn?.length && driver?.onboardingLicenceFillStatus && !driver?.isLicenseReview) ? "Pending" : ""}
                      driver={driver}
                      reasons={selectedReason}
                      refreshData={refreshData}
                    />
                  )
                case "Insurance Status":
                  return (
                    <ResetDocumentStatus
                      title={title}
                      status={driver?.isInsuranceReview ? "Approved" : insuranceReaosn?.length ?  "Rejected" : (!insuranceReaosn?.length && driver?.onboardingVehicleFillStatus && !driver?.isInsuranceReview) ? "Pending" : ""}
                      driver={driver}
                      reasons={selectedInsuranceReason}
                      refreshData={refreshData}
                    />
                  )
                case "Signature Status":
                  return (
                    <ResetDocumentStatus
                      title={title}
                      status={driver?.isSignatureReview ? "Approved" : signatureReaosn?.length ?  "Rejected" : (!signatureReaosn?.length && driver?.onboardingTaxFillStatus && !driver?.isSignatureReview) ? "Pending" : ""}
                      driver={driver}
                      reasons={selectedSignatureReason}
                      refreshData={refreshData}
                    />
                  )
                default:
                  return <React.Fragment>{output}</React.Fragment>;
              }
            })()}
          </span>
        </li>
      );
    },
    [driver, driverData, currentUser, id]
  );

  const BriefItems = ({ fields, className, mainTitle, width, edit }) => {
    return (
      <ul
        className={`brief brief_${classNameNormalize(className)}`}
        style={{ width: "100%" }}
      >
        {fields.map((field, index) => {
          const props = field instanceof Object ? field : { field };
          return (
            <BriefItem
              key={index}
              {...props}
              mainTitle={mainTitle}
              width={width}
              edit={edit}
            />
          );
        })}
      </ul>
    );
  };

  const Brief = ({ fields, title, long, width, edit }) => {
    return (
      <div className="form__col form__col_height-flex">
        <div className="section">
          <h3 className={cn("section__title", { section__title_long: long })}>{title}:</h3>
          <BriefItems fields={fields} className={title} mainTitle={title} width={width} edit={edit} />
          {title === "Signature" && (signatureReaosn?.length > 0 || driver?.onboardingTaxFillStatus || driver?.isSignatureReview) && (
            <>
              <div className="document_approv">
                <p className="document_approv__title">Documentation Approval</p>

                <ButtonGroup size="large" style={{ width: "100%" }} variant="outlined" aria-label="Basic button group">
                  <Button
                    className={`document_approv__btn ${(documentApproval.signatureApproval || (driver?.isSignatureReview && !unapproveOverride.signatureApproval)) && "document_approv__approved"}`}
                    onClick={() => {
                      setDocumentApproval({
                        ...documentApproval,
                        signatureApproval: true,
                      });
                      setUnapproveOverride((prev) => ({ ...prev, signatureApproval: false }));
                      setSelectedSignatureReason([]);
                      handleApprovreDriverDocument("Signature W9");
                    }}
                  >
                    Approved
                  </Button>
                  <Button
                    className={`document_approv__btn ${!(documentApproval.signatureApproval || (driver?.isSignatureReview && !unapproveOverride.signatureApproval)) && "document_approv__not-approved"}`}
                    onClick={() => {
                      setDocumentApproval({
                        ...documentApproval,
                        signatureApproval: false,
                      });
                      setUnapproveOverride((prev) => ({ ...prev, signatureApproval: true }));
                      handleGetReason();
                    }}
                  >
                    Not Approved
                  </Button>
                </ButtonGroup>
              </div>
              <div className="not-appeoved_reason">
                <p className="not-appeoved_reason__title">
                  Select Reasons <span>(one or more)</span>
                </p>

                <div className="not-appeoved_reason__contaier">
                  {reasonData.signatureReasonData.map((reas, i) => (
                    <div className="not-appeoved_reason__lable">
                      <Checkbox
                        className="not-appeoved_reason_checkbox"
                        checked={selectedSignatureReason.includes(reas._id)}
                        onChange={(e) =>
                          handleChangedReason({
                            reas: reas._id,
                            selected: e.target.checked,
                            setSelectedState: setSelectedSignatureReason,
                            selectedState: selectedSignatureReason,
                            type: driveDocumentType.signature,
                          })
                        }
                        disabled={documentApproval.signatureApproval || (driver?.isSignatureReview && !unapproveOverride.signatureApproval)}
                      />
                      <div>
                        <p>{reas.reason} </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
          {title === "Primary" && currentUser?.role === "root" && (
            <div style={{ position: "relative" }}>
              <button className="btn btn_accent customized-details-btn driver-operator" onClick={() => setSwitchRole([true, id])}>
                Change driver to operator
              </button>
              {isLoading && (
                <CircularProgress
                  size={18}
                  sx={{
                    color: "#4195f5",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-8px",
                    marginLeft: "-10px",
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const refreshData = () => {
    actions.refetch.setIsDataRefetch(true);
  };
  const handleStatus = (result, status, message) => {
    if (
      ["blocked", "unblocked"].includes(status)
        ? status === "blocked"
          ? result?.data?.isBlocked
          : !result?.data?.isBlocked
        : status === "onboard"
          ? result?.data?.status === "approved"
          : result?.data?.status === status
    ) {
      sendSuccessMessage(
        message
          ? message
          : `Driver ${status === "onboard" ? "onboarded" : status} successfully`
      );
      refreshData();
    } else {
      checkForError(result?.data?.error || result?.error || result);
    }
  };

  const handleSwitchRole = async (id) => {
    let response = await changeRole({
      id: id,
      role: "operator",
    });
    if (response && response?.data?.role) {
      sendSuccessMessage(`${response.data.role} role assigned successfully`);
      actions.modal.closeDriver();
      actions.refetch.setIsDataRefetch(true);
      setSwitchRole([false, ""]);
    } else {
      sendErrorMessage(`${response.data.message}`);
      setSwitchRole([false, ""]);
    }
  };

  const handleReasonUI = () => {
    if (
      driver?.offboardedReason ||
      (driver?.inactivatedReason && driver?.offboardedReason)
    ) {
      return driver?.offboardedReason;
    } else if (driver?.inactivatedReason) {
      return driver?.inactivatedReason;
    } else {
      return false;
    }
  };

  const ImageLoader = ({ type }) => {
    return (
      <div style={{ height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </div>
    )
  }


  const handleRefreshBranch = async () => {
   const data = await refreshDriverBranchApi(id);

   if (!data.error) {
    sendSuccessMessage(data.message);
    refetch()
   }
  }

    useEffect(() => {
    if (reasonApiData?.length) {
      const suspensionReasonData = reasonApiData.filter((item) => item.type === "suspension")
      const licenseReasonData = reasonApiData.filter((item) => item.type === driveDocumentType.driversLicense)
      const insuranceReasonData = reasonApiData.filter((item) => item.type === driveDocumentType.insurancePolicy)
      const selfieReasonData = reasonApiData.filter((item) => item.type === driveDocumentType.selfie)
      const signatureReasonData = reasonApiData.filter((item) => item.type === driveDocumentType.signature)

      setReasonData({
        suspensionReasonData,
        licenseReasonData,
        insuranceReasonData,
        selfieReasonData,
        signatureReasonData
      })
    }
  }, [reasonApiData]);


  useEffect(() => {
     handleGetReason()
  }, [driver]);

  const selfieReaosn = driver?.documentReasons?.filter((item) => item.type === driveDocumentType.selfie)?.map((item) => item._id);
  const driverReaosn = driver?.documentReasons?.filter((item) => item.type === driveDocumentType.driversLicense)?.map((item) => item._id);
  const insuranceReaosn = driver?.documentReasons?.filter((item) => item.type === driveDocumentType.insurancePolicy)?.map((item) => item._id);
  const signatureReaosn = driver?.documentReasons?.filter((item) => item.type === driveDocumentType.signature)?.map((item) => item._id) || [];

  const handleGetReason = () => {
      setSelectedSelfieReason(selfieReaosn || [])
      setSelectedInsuranceReason(insuranceReaosn || [])
      setSelectedReason(driverReaosn || [])
      setSelectedSignatureReason(signatureReaosn || [])
  }

  const handleChangedReason = ({reas, selected, setSelectedState, selectedState, type}) => {
    const updated = selected
      ? [...selectedState, reas]
      : selectedState.filter((item) => item !== reas);
    setSelectedState(updated);
    if (type && updated.length) {
      applyDocReview(type, updated);
    }
  };

  const applyDocReview = async (type, reasons) => {
    const payload = { driver: id, docApproval: [{ type, reasons }] };
    const result = await documentApprovalFn(payload);
    if (result?.error) {
      return checkForError(result);
    }
    sendSuccessMessage("Driver Rreview saved successfully...");
    actions.refetch.setIsDataRefetch(true);
    refetch();
  };

  

  const handleApprovreDriverDocument = async (type) => {
    const formatedType = {
      "Insurance Policy": "insurancePolicy",
      "Driver License": "driversLicense",
      "Personal Profile": "selfie",
      "Signature W9": "signature",
    }
    const payload = {
      driver: id,
      docApproval: [{type: formatedType[type]}],
    };

    const result = await documentApprovalFn(payload);

    if (result?.error) {
      return checkForError(result);
    }

    sendSuccessMessage("Driver Rreview saved successfully...");
    if (showComfirmApproveModal) {
      setShowComfirmApproveModal("");
    }
    setDocumentApproval({
      licenceApproval: false,
      selfieApproval: false,
      insuranceApproval: false,
      signatureApproval: false,
    })
    setUnapproveOverride({
      licenceApproval: false,
      selfieApproval: false,
      insuranceApproval: false,
      signatureApproval: false,
    })
    actions.refetch.setIsDataRefetch(true);
    refetch()
  };

  const handleReviewDocument = async () => {
    try {
      let payload = { driver: id, docApproval: [] };

      const addDocApproval = (selectedReason, type) => {
        if (selectedReason?.length) {
           payload.docApproval.push({
             type,
             reasons: selectedReason
           });
        }
      };

      addDocApproval(selectedSelfieReason, driveDocumentType.selfie);
      addDocApproval(selectedReason, driveDocumentType.driversLicense);
      addDocApproval(selectedInsuranceReason, driveDocumentType.insurancePolicy);
      addDocApproval(selectedSignatureReason, driveDocumentType.signature);

      const result = await documentApprovalFn(payload);

      if (result?.error) {
        return checkForError(result);
      }

      sendSuccessMessage("Driver Rreview saved successfully...");
      if (showComfirmApproveModal) {
        setShowComfirmApproveModal("");
      }

      setDocumentApproval({
        licenceApproval: false,
        selfieApproval: false,
        insuranceApproval: false,
        signatureApproval: false,
      })
      setUnapproveOverride({
        licenceApproval: false,
        selfieApproval: false,
        insuranceApproval: false,
        signatureApproval: false,
      })
      actions.refetch.setIsDataRefetch(true);
      refetch()
    } catch (error) {
      console.error("Error in handleReviewDocument:", error);
      checkForError(error);
    }
  };

  const arraysAreEqual = (a = [], b = []) => {
    if (!a.length && !b.length) return false
    if (a?.length !== b?.length) return false;
    return a.every((item) => b.includes(item));
  };

  return (
    <React.Fragment>
      <SwitchRoleConfirmation
        switchRole={switchRole}
        setSwitchRole={setSwitchRole}
        handleSwitchRole={handleSwitchRole}
        name={"operator"}
        title={"Change driver to operator"}
      />
      <Modal
        open
        onClose={() => actions.modal.closeDriver()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`modal modal_wide ${!driverLoading ? "after-loading" : "when-loading"}`}>
          <div className="modal__header">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h2 className="modal__title">{driver && driver?.username ? driver?.username : ""}</h2>
              <ClearIcon style={{ cursor: "pointer" }} onClick={() => actions.modal.closeDriver()} />
            </div>
          </div>
          <div className="modal__body">
            {!driverLoading ? (
              <div className="form__row">
                {(driver?.inactivatedReason || driver?.offboardedReason) && (
                  <div
                    className="form__row section reason__container"
                    style={{
                      gap: "unset",
                      paddingTop: "0.2rem",
                      paddingBottom: "0.2rem",
                    }}
                  >
                    <h3 className={cn("section__title reason__container__title")}>Reason:</h3>
                    {handleReasonUI() && <p className="reason__container__reason">{handleReasonUI() ? handleReasonUI() : ""}</p>}
                  </div>
                )}

                <div className="form__col form__col_full-width">
                  <div className="section section_group">
                    <h3 className="section__title">Driver under review</h3>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingTop: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <img style={{ width: "22px" }} src={warningIconYlow} />
                        <p style={{ margin: 0, fontSize: "15px" }}>
                          {driver?.underReview?.reason || "Mark this driver as under review if they have committed..."}
                        </p>
                        {!!driver?.underReview?.reason && (
                          <button
                            style={{ color: "blue", border: "none", backgroundColor: "inherit", marginLeft: "0.5rem" }}
                            onClick={() => {
                              setShowMur(true);
                            }}
                          >
                            <EditIcon style={{ width: "18px", height: "18px", color: "black" }} />
                          </button>
                        )}
                      </div>
                      <FormControlLabel
                        control={
                          <Android12Switch checked={!!driver?.underReview?.reason} onChange={(e) => handleMurSwitch(e.target.checked)} />
                        }
                        label=""
                        style={{ margin: 0 }}
                      />
                    </div>
                  </div>
                </div>

                <div className="form__row">
                  <Brief title="Primary" fields={fields.primary} edit={true} />
                  <div className="form__col">
                    <div className="section">
                      <h3 className="section__title">Personal:</h3>
                      <div className="brief__union">
                        <BriefItems fields={fields.personal} edit={true} />
                      </div>

                      <div className="license">
                        <button className="btn license__btn-show-switch" onClick={() => setShowProfile(!showProfile)}>
                          {showProfile ? (
                            <React.Fragment>
                              Hide Profile Photo
                              <IoIosArrowUp className="btn__icon btn__icon_right" />
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              Show Profile Photo
                              <IoIosArrowDown className="btn__icon btn__icon_right" />
                            </React.Fragment>
                          )}
                        </button>
                      </div>
                      {showProfile && (
                        <>
                          <div className="license__item section">
                            <div style={{ position: "relative" }}>
                              {profilePhotoLoading || isImageChange === "profilePhoto" ? (
                                <ImageLoader type="profilePhoto" />
                              ) : (
                                <RotatableImage src={profileImg} />
                              )}
                            </div>

                            <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                              <div className="file-upload">
                                <label className={`file-upload__btn`}>
                                  <input type="file" onChange={fileUpload("profilePhoto", "uploadProfilePhoto")} accept="image/*" />
                                  <span className="btn btn_accent">
                                    <FaFileUpload className="btn__icon" />
                                    Choose File
                                  </span>
                                  <div className={`form__msg form__msg_warning`} style={{ color: !imgLimit.profilePhoto && "grey" }}>
                                    <span>{imgLimit?.profileMsg}</span>
                                  </div>
                                </label>
                              </div>
                              {!(profilePhotoLoading || isImageChange === "profilePhoto") && (
                                <ImagePreviewModal imageSrc={profileImg} imageInfo={generateImageInfo("profile", driverData)} />
                              )}
                            </div>
                          </div>

                          {(selfieReaosn?.length > 0 || driver?.onboardingDriverBadgeFillStatus || driver?.isSelfieReview) && (
                            <>
                              <div className="document_approv">
                                <p className="document_approv__title">Documentation Approval</p>

                                <ButtonGroup size="large" style={{ width: "100%" }} variant="outlined" aria-label="Basic button group">
                                  <Button
                                    className={`document_approv__btn ${(documentApproval.selfieApproval || (driver?.isSelfieReview && !unapproveOverride.selfieApproval)) && "document_approv__approved"}`}
                                    onClick={() => {
                                      setDocumentApproval({
                                        ...documentApproval,
                                        selfieApproval: true,
                                      });
                                      setUnapproveOverride((prev) => ({ ...prev, selfieApproval: false }));
                                      setSelectedSelfieReason([]);
                                      handleApprovreDriverDocument("Personal Profile");
                                    }}
                                  >
                                    Approved
                                  </Button>
                                  <Button
                                    className={`document_approv__btn ${
                                      !(documentApproval.selfieApproval || (driver?.isSelfieReview && !unapproveOverride.selfieApproval)) && "document_approv__not-approved"
                                    }`}
                                    onClick={() => {
                                      setDocumentApproval({
                                        ...documentApproval,
                                        selfieApproval: false,
                                      });
                                      setUnapproveOverride((prev) => ({ ...prev, selfieApproval: true }));
                                      handleGetReason();
                                    }}
                                  >
                                    Not Approved
                                  </Button>
                                </ButtonGroup>
                              </div>
                              <div className="not-appeoved_reason">
                                <p className="not-appeoved_reason__title">
                                  Select Reasons <span>(one or more)</span>
                                </p>

                                <div className="not-appeoved_reason__contaier">
                                  {reasonData.selfieReasonData.map((reas, i) => (
                                    <div className="not-appeoved_reason__lable">
                                      <Checkbox
                                        className="not-appeoved_reason_checkbox"
                                        checked={selectedSelfieReason.includes(reas._id)}
                                        onChange={(e) =>
                                          handleChangedReason({
                                            reas: reas._id,
                                            selected: e.target.checked,
                                            setSelectedState: setSelectedSelfieReason,
                                            selectedState: selectedSelfieReason,
                                            type: driveDocumentType.selfie,
                                          })
                                        }
                                        disabled={documentApproval.selfieApproval || (driver?.isSelfieReview && !unapproveOverride.selfieApproval)}
                                      />
                                      <div>
                                        <p>{reas.reason} </p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form__row form__col_full-width">
                  <Brief title="Time/Schedule" fields={fields.timeSchedule} className="brief_time-schedule" />
                  <Brief title="Device Info" fields={fields.deviceInfo} width={1} />
                </div>

                <Brief title="Car/Vehicle" fields={fields.carVehicle} width={18} edit={true} />

                <Brief title="Onboarding status" fields={fields.onboarding} width={50} />

                <div className="form__col form__col_full-width">
                  <div className="section section_group">
                    <h3 className="section__title">Tax Information:</h3>
                    <div className="form__row">
                      <Brief title="Basic" fields={fields.basic} width={1} />

                      <Brief title="Signature" fields={fields.signature} width={62} edit={true} />

                      <Brief title="Tax Identify Information" fields={fields.tax} width={1} />

                      {/* <Brief
                        long
                        title="Request for Taxpayer Identification Number and Certification"
                        fields={fields.taxpayerRequest}
                        width={65}
                      /> */}
                      <Terms driver={driver} title="Terms" fields={driver?.terms ?? []} />
                    </div>
                  </div>
                </div>

                <div className="form__col form__col_full-width">
                  <div className="section">
                    <h3 className="section__title">Driver License:</h3>

                    {/*maybe must union driverLicense1 and driverLicense2 to one object?*/}
                    <div className="brief__union">
                      <BriefItems fields={fields.driverLicense1} />
                      <BriefItems fields={fields.driverLicense2} edit={false} />
                    </div>

                    <div className="license">
                      <button className="btn license__btn-show-switch" onClick={() => setShowLicense(!showLicense)}>
                        {showLicense ? (
                          <React.Fragment>
                            Hide license <IoIosArrowUp className="btn__icon btn__icon_right" />
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            Show license <IoIosArrowDown className="btn__icon btn__icon_right" />
                          </React.Fragment>
                        )}
                      </button>

                      {showLicense && (
                        <div className="license__body">
                          <div className="license__items-holder">
                            <div className="license__item">
                              <div className="section">
                                <h4 className="section__title">Front:</h4>

                                <div style={{ position: "relative" }}>
                                  {frontLoading || debugLicenceLoading || isImageChange === "front" ? (
                                    <ImageLoader type="front" />
                                  ) : (
                                    <RotatableImage src={licenseFrontImg} />
                                  )}
                                </div>

                                <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                                  <div className="file-upload">
                                    <label className={`file-upload__btn`}>
                                      <input type="file" onChange={fileUpload("front", "uploadLicense")} accept="image/*" />
                                      <span className="btn btn_accent">
                                        <FaFileUpload className="btn__icon" />
                                        Choose File
                                      </span>
                                      <div className={`form__msg form__msg_warning`} style={{ color: !imgLimit.front && "grey" }}>
                                        <span>{imgLimit?.frontMsg}</span>
                                      </div>
                                    </label>
                                  </div>
                                  {!(frontLoading || debugLicenceLoading || isImageChange === "front") && (
                                    <ImagePreviewModal
                                      imageSrc={licenseFrontImg}
                                      imageInfo={generateImageInfo("license-front", driverData)}
                                    />
                                  )}
                                </div>
                              </div>
                              {(driverReaosn?.length > 0 || driver?.onboardingLicenceFillStatus || driver?.isLicenseReview) && (
                                <div className="document_approv">
                                  <p className="document_approv__title">Documentation Approval</p>

                                  <ButtonGroup size="large" style={{ width: "100%" }} variant="outlined" aria-label="Basic button group">
                                    <Button
                                      className={`document_approv__btn ${(documentApproval.licenceApproval || (driver?.isLicenseReview && !unapproveOverride.licenceApproval)) && "document_approv__approved"}`}
                                      onClick={() => {
                                        setDocumentApproval({
                                          ...documentApproval,
                                          licenceApproval: true,
                                        });
                                        setUnapproveOverride((prev) => ({ ...prev, licenceApproval: false }));
                                        setSelectedReason([]);
                                        handleApprovreDriverDocument("Driver License");
                                      }}
                                    >
                                      Approved
                                    </Button>
                                    <Button
                                      className={`document_approv__btn ${
                                        !(documentApproval.licenceApproval || (driver?.isLicenseReview && !unapproveOverride.licenceApproval)) && "document_approv__not-approved"
                                      }`}
                                      onClick={() => {
                                        setDocumentApproval({
                                          ...documentApproval,
                                          licenceApproval: false,
                                        });
                                        setUnapproveOverride((prev) => ({ ...prev, licenceApproval: true }));
                                        handleGetReason();
                                      }}
                                    >
                                      Not Approved
                                    </Button>
                                  </ButtonGroup>
                                </div>
                              )}
                            </div>

                            <div className="license__item">
                              <div className="section">
                                <h4 className="section__title">Back:</h4>
                                <div style={{ position: "relative" }}>
                                  {backLoading || debugLicenceLoading || isImageChange === "back" ? (
                                    <ImageLoader type="back" />
                                  ) : (
                                    <RotatableImage src={licenseBackImg} />
                                  )}
                                </div>

                                <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                                  <div className="file-upload">
                                    <label className={`file-upload__btn`}>
                                      <input type="file" onChange={fileUpload("back", "uploadLicense")} accept="image/*" />
                                      <span className="btn btn_accent">
                                        <FaFileUpload className="btn__icon" />
                                        Choose File
                                      </span>
                                      <div className={`form__msg form__msg_warning`} style={{ color: !imgLimit.back && "grey" }}>
                                        <span>{imgLimit?.backMsg}</span>
                                      </div>
                                    </label>
                                  </div>
                                  {!(backLoading || debugLicenceLoading || isImageChange === "back") && (
                                    <ImagePreviewModal
                                      imageSrc={licenseBackImg}
                                      imageInfo={generateImageInfo("license-back", driverData)}
                                    />
                                  )}
                                </div>
                              </div>
                              {(driverReaosn?.length > 0 || driver?.onboardingLicenceFillStatus || driver?.isLicenseReview) && (
                                <div className="not-appeoved_reason">
                                  <p className="not-appeoved_reason__title">
                                    Select Reasons <span>(one or more)</span>
                                  </p>

                                  <div className="not-appeoved_reason__contaier">
                                    {reasonData.licenseReasonData.map((reas, i) => (
                                      <div className="not-appeoved_reason__lable">
                                        <Checkbox
                                          className="not-appeoved_reason_checkbox"
                                          checked={selectedReason.includes(reas._id)}
                                          onChange={(e) =>
                                            handleChangedReason({
                                              reas: reas._id,
                                              selected: e.target.checked,
                                              setSelectedState: setSelectedReason,
                                              selectedState: selectedReason,
                                              type: driveDocumentType.driversLicense,
                                            })
                                          }
                                          disabled={documentApproval.licenceApproval || (driver?.isLicenseReview && !unapproveOverride.licenceApproval)}
                                        />
                                        <div>
                                          <p>{reas.reason} </p>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* {!["completed", "rejected"].includes(driver.onboardingLicenceFillStatus) && (
                            <div className="btn-bar">
                              <div style={{ position: "relative" }}>
                                <button
                                  className={cn("btn", {
                                    btn_disabled: updateReq.isLoading,
                                  })}
                                  onClick={() =>
                                    update({
                                      _id: driver._id,
                                      onboardingLicenceFillStatus: "rejected",
                                    })
                                  }
                                >
                                  Reject
                                  {updateReq.isLoading && <div style={{ width: "25px" }}></div>}
                                </button>
                                {updateReq.isLoading && (
                                  <CircularProgress
                                    size={18}
                                    sx={{
                                      color: "#fff",
                                      position: "absolute",
                                      top: "50%",
                                      left: "83%",
                                      marginTop: "-8px",
                                      marginLeft: "-10px",
                                    }}
                                  />
                                )}
                              </div>
                              <div style={{ position: "relative" }}>
                                {updateReq.isLoading && (
                                  <CircularProgress
                                    size={18}
                                    sx={{
                                      color: "#fff",
                                      position: "absolute",
                                      top: "50%",
                                      left: "25%",
                                      marginTop: "-8px",
                                      marginLeft: "-10px",
                                      zIndex: "9",
                                    }}
                                  />
                                )}
                                <button
                                  className={cn("btn btn_accent", {
                                    btn_disabled: updateReq.isLoading,
                                  })}
                                  onClick={() =>
                                    update({
                                      _id: driver._id,
                                      onboardingLicenceFillStatus: "completed",
                                    })
                                  }
                                >
                                  {!updateReq.isLoading ? <FaCheck className="btn__icon" /> : <div style={{ width: "25%" }}></div>}
                                  Approve
                                </button>
                              </div>
                            </div>
                          )} */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form__row">
                  <div className="form__col section">
                    <h3 className="section__title">Insurance Policy:</h3>
                    <div className="brief__union">
                      <BriefItems fields={fields.insurancePolicy} />
                    </div>

                    <div className="license">
                      <button className="btn license__btn-show-switch" onClick={() => setShowPolicy(!showPolicy)}>
                        {showPolicy ? (
                          <React.Fragment>
                            Hide Policy
                            <IoIosArrowUp className="btn__icon btn__icon_right" />
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            Show Policy
                            <IoIosArrowDown className="btn__icon btn__icon_right" />
                          </React.Fragment>
                        )}
                      </button>
                      {showPolicy && (
                        <>
                          <div className="license__body">
                            <div className="license__items-holder">
                              <div className="license__item">
                                <div className="section">
                                  <h4 className="section__title">Insurance :</h4>
                                  <div style={{ position: "relative" }}>
                                    {debugInsuranceLoading || isImageChange === "file" ? (
                                      <ImageLoader type="file" />
                                    ) : (
                                      <RotatableImage src={insuranceImg} />
                                    )}
                                  </div>

                                  <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                                    <div className="file-upload">
                                      <label className={`file-upload__btn`}>
                                        <input type="file" onChange={fileUpload("insurance", "uploadInsurance")} accept="image/*" />
                                        <span className="btn btn_accent">
                                          <FaFileUpload className="btn__icon" />
                                          Choose File
                                        </span>
                                        <div className={`form__msg form__msg_warning`} style={{ color: !imgLimit.insurance && "grey" }}>
                                          <span>{imgLimit?.insuranceMsg}</span>
                                        </div>
                                      </label>
                                    </div>
                                    {!(debugInsuranceLoading || isImageChange === "file") && (
                                      <ImagePreviewModal imageSrc={insuranceImg} imageInfo={generateImageInfo("insurance", driverData)} />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="license__item">
                                {optionalInsuranceImg && (
                                  <div className="section">
                                    <h4 className="section__title">Optional insurance :</h4>
                                    <div style={{ position: "relative" }}>
                                      {debugInsuranceLoading || isOptionalImageChange === "optionalFile" ? (
                                        <ImageLoader type="file" />
                                      ) : (
                                        <RotatableImage src={optionalInsuranceImg} />
                                      )}
                                    </div>

                                    <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                                      <div className="file-upload">
                                        <label className={`file-upload__btn`}>
                                          <input
                                            type="file"
                                            onChange={fileUpload("insuranceOptional", "uploadInsurance")}
                                            accept="image/*"
                                          />
                                          <span className="btn btn_accent">
                                            <FaFileUpload className="btn__icon" />
                                            Choose File
                                          </span>
                                          <div
                                            className={`form__msg form__msg_warning`}
                                            style={{ color: !imgLimit.insuranceOptional && "grey" }}
                                          >
                                            <span>{imgLimit?.insuranceOptionalMsg}</span>
                                          </div>
                                        </label>
                                      </div>
                                      {!(debugInsuranceLoading || isOptionalImageChange === "optionalFile") && (
                                        <ImagePreviewModal
                                          imageSrc={optionalInsuranceImg}
                                          imageInfo={generateImageInfo("insurance", driverData)}
                                        />
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {(insuranceReaosn?.length > 0 || driver?.onboardingVehicleFillStatus || driver?.isInsuranceReview) && (
                            <>
                              <div style={{ display: "flex", width: "100%" }}>
                                <div className="document_approv" style={{ width: "50%" }}>
                                  <p className="document_approv__title">Documentation Approval</p>

                                  <ButtonGroup size="large" style={{ width: "100%" }} variant="outlined" aria-label="Basic button group">
                                    <Button
                                      className={`document_approv__btn ${
                                        (documentApproval.insuranceApproval || (driver?.isInsuranceReview && !unapproveOverride.insuranceApproval)) && "document_approv__approved"
                                      }`}
                                      onClick={() => {
                                        setDocumentApproval({
                                          ...documentApproval,
                                          insuranceApproval: true,
                                        });
                                        setUnapproveOverride((prev) => ({ ...prev, insuranceApproval: false }));
                                        setSelectedInsuranceReason([]);
                                        handleApprovreDriverDocument("Insurance Policy");
                                      }}
                                    >
                                      Approved
                                    </Button>
                                    <Button
                                      className={`document_approv__btn ${
                                        !(documentApproval.insuranceApproval || (driver?.isInsuranceReview && !unapproveOverride.insuranceApproval)) && "document_approv__not-approved"
                                      }`}
                                      onClick={() => {
                                        setDocumentApproval({
                                          ...documentApproval,
                                          insuranceApproval: false,
                                        });
                                        setUnapproveOverride((prev) => ({ ...prev, insuranceApproval: true }));
                                        handleGetReason();
                                      }}
                                    >
                                      Not Approved
                                    </Button>
                                  </ButtonGroup>
                                </div>
                                <div className="not-appeoved_reason">
                                  <p className="not-appeoved_reason__title">
                                    Select Reasons <span>(one or more)</span>
                                  </p>

                                  <div className="not-appeoved_reason__contaier">
                                    {reasonData.insuranceReasonData.map((reas, i) => (
                                      <div className="not-appeoved_reason__lable">
                                        <Checkbox
                                          className="not-appeoved_reason_checkbox"
                                          checked={selectedInsuranceReason.includes(reas._id)}
                                          onChange={(e) =>
                                            handleChangedReason({
                                              reas: reas._id,
                                              selected: e.target.checked,
                                              setSelectedState: setSelectedInsuranceReason,
                                              selectedState: selectedInsuranceReason,
                                              type: driveDocumentType.insurancePolicy,
                                            })
                                          }
                                          disabled={documentApproval.insuranceApproval || (driver?.isInsuranceReview && !unapproveOverride.insuranceApproval)}
                                        />
                                        <div>
                                          <p>{reas.reason} </p>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="section" style={{ width: "49%" }}>
                  <h3 className="section__title">Background</h3>
                  <ul className="brief brief_null">
                    <li className="brief__item brief__item_has-been convicted">
                      <span className="brief__item-cell brief__item-cell_title">Background Status:</span>
                      <span style={handleBackgroundStatusesBadge(driver?.checkrBackgroundStatus)}>{driver?.checkrBackgroundStatus}</span>
                      {!driver?.consents?.consentId && !driver?.checkrBackgroundStatus && <React.Fragment>No Consent</React.Fragment>}
                      {driver?.consents?.consentId && !driver?.checkrBackgroundStatus && <React.Fragment>Consent Given</React.Fragment>}
                      {/* {!driver?.checkrBackgroundStatus && (
                        <button
                          className="btn btn_accent customized-details-btn"
                          type="button"
                          onClick={async () => {
                            const response = await backgroundCheck({
                              _id: driver._id,
                            });
                            if (response?.data?.status != 200) {
                              checkForError(response);
                            }
                          }}
                        >
                          Check
                        </button>
                      )} */}
                    </li>
                  </ul>

                  {driver?.btReview && (
                    <div style={{ marginLeft: "0.3rem" }}>
                      <div style={{ display: "flex", gap: "5px", marginTop: "0.2rem" }}>
                        <span style={{ fontWeight: "600", width: "22%" }}>BT Review :</span>
                        {!driver?.btReview?.isVerified ? (
                          <div style={{ width: "78%" }}>
                            <button
                              style={{ minHeight: "0.2rem", fontSize: "13px", padding: "1.5px 4px" }}
                              className="btn btn_accent"
                              onClick={() => {
                                actions.modal.openReason({
                                  obj: driver,
                                  title: "BT__REVIEW",
                                });
                              }}
                            >
                              Verify
                            </button>
                          </div>
                        ) : (
                          <div style={{ width: "78%" }}>
                            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              {"Verify by "} {driver?.btReview?.userId?.username}{" "}
                              {`(${moment(driver?.btReview?.date).format("MM/DD/YYYY hh:mm A")})`}
                            </span>
                          </div>
                        )}
                      </div>
                      {driver?.btReview?.isVerified && (
                        <span style={{ marginTop: "0.2rem" }}>
                          <p style={{ marginBottom: "0px", display: "flex", alignItems: "center", gap: "5px" }}>
                            <div style={{ width: "22%", display: "flex", justifyContent: "right" }}>
                              <span style={{ fontWeight: "600" }}> Remark : </span>
                            </div>
                            <div>
                              <span style={{ widows: "78%" }}>{`${driver?.btReview?.remark || "-"} `}</span>
                            </div>
                          </p>
                        </span>
                      )}
                    </div>
                  )}

                  {driver.onboardingBackgroundFillStatus === "pending" && (
                    <div className="btn-bar">
                      <div style={{ position: "relative" }}>
                        {updateReq.isLoading && (
                          <CircularProgress
                            size={18}
                            sx={{
                              color: "#fff",
                              position: "absolute",
                              top: "50%",
                              left: "83%",
                              marginTop: "-8px",
                              marginLeft: "-10px",
                              zIndex: "9",
                            }}
                          />
                        )}
                        <button
                          className={cn("btn btn_accent", {
                            btn_disabled: updateReq.isLoading,
                          })}
                          onClick={() =>
                            update({
                              _id: driver._id,
                              onboardingBackgroundFillStatus: "completed",
                            })
                          }
                        >
                          {updateReq.isLoading ? <FaCheck className="btn__icon" /> : <div style={{ width: "25%" }}></div>}
                          Approve
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="form__col form__col_full-width_">
                  {/* <div className="section"> */}
                  {/* <h3 className="section__title">Other Works:</h3>

                    <ul className="brief brief_null">
                      <li className="brief__item brief__item_has-been convicted">
                        <span className="brief__item-cell brief__item-cell_title">General Warehousing:</span>
                        <span className="brief__item-cell brief__item-cell_value">
                          {driver && driver.readyToGeneralWarehousing ? (
                            <React.Fragment>Yes</React.Fragment>
                          ) : (
                            <React.Fragment>No</React.Fragment>
                          )}
                        </span>
                      </li>

                      <li className="brief__item brief__item_has-previous names">
                        <span className="brief__item-cell brief__item-cell_title">Package Sortation:</span>
                        <span className="brief__item-cell brief__item-cell_value">
                          {driver && driver.readyToPackageSortation ? (
                            <React.Fragment>Yes</React.Fragment>
                          ) : (
                            <React.Fragment>No</React.Fragment>
                          )}
                        </span>
                      </li>

                      <li className="brief__item brief__item_send-background copy">
                        <span className="brief__item-cell brief__item-cell_title">Picking / Packing / Fulfillment:</span>
                        <span className="brief__item-cell brief__item-cell_value">
                          {driver && driver.readyToPickingPackingFulfillment ? (
                            <React.Fragment>Yes</React.Fragment>
                          ) : (
                            <React.Fragment>No</React.Fragment>
                          )}
                        </span>
                      </li>
                    </ul> */}

                  <div className="section">
                    <h3 className="section__title">OAI Insurance: </h3>
                    {driverData?.OAI?.isOwnOAI ? (
                      <>
                        <div className="brief__union">
                          <BriefItems fields={fields.OIA_insurance} />
                        </div>

                        <div className="license">
                          <button className="btn license__btn-show-switch" onClick={() => setShowOAI(!showOAI)}>
                            {showOAI ? (
                              <React.Fragment>
                                Hide Insurance
                                <IoIosArrowUp className="btn__icon btn__icon_right" />
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                Show Insurance
                                <IoIosArrowDown className="btn__icon btn__icon_right" />
                              </React.Fragment>
                            )}
                          </button>
                          {showOAI && (
                            <div className="license__body">
                              <div className="license__items-holder">
                                <div className="license__item section">
                                  <div style={{ position: "relative" }}>
                                    {oaiLoading || isImageChange === "oaiPhoto" ? (
                                      <ImageLoader type="file" />
                                    ) : (
                                      <RotatableImage src={OAIInsurance} />
                                    )}
                                  </div>

                                  <div style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "space-between" }}>
                                    <div className="file-upload">
                                      <label className={`file-upload__btn`}>
                                        <input type="file" onChange={fileUpload("oaiPhoto", "uploadOAI")} accept="image/*" />
                                        <span className="btn btn_accent">
                                          <FaFileUpload className="btn__icon" />
                                          Choose File
                                        </span>
                                        <div className={`form__msg form__msg_warning`} style={{ color: !imgLimit.file && "grey" }}>
                                          <span>{imgLimit?.fileMsg}</span>
                                        </div>
                                      </label>
                                    </div>
                                    {!(oaiLoading || isImageChange === "oaiPhoto") && (
                                      <ImagePreviewModal
                                        imageSrc={OAIInsurance}
                                        imageInfo={generateImageInfo("oai-insurance", driverData)}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    ) : driverData?.OAI?.isOwnOAI === false ? (
                      <span style={{ fontSize: "16px", display: "flex", gap: "10px", alignItems: "center" }}>
                        Purchased via Better Trucks
                        {currentUser && currentUser.role === "root" && (
                          <DeleteIcon style={{ cursor: "pointer" }} onClick={() => setShowDialog(true)} sx={{ color: "red" }} />
                        )}
                        {currentUser && currentUser.role === "root" && (
                          <button
                            className="btn btn_block btn_accent customized-details-btn w-auto"
                            onClick={() => actions.modal.openOAILogs(id)}
                            type="button"
                          >
                            Logs
                          </button>
                        )}
                      </span>
                    ) : (
                      <span style={{ fontSize: "14px", display: "flex", gap: "10px", alignItems: "center" }}>
                        No data available
                        {currentUser && currentUser.role === "root" && (
                          <button
                            className="btn btn_block btn_accent customized-details-btn w-auto"
                            onClick={() => actions.modal.openOAILogs(id)}
                            type="button"
                          >
                            Logs
                          </button>
                        )}
                      </span>
                    )}
                  </div>
                  {/* </div> */}
                </div>

                {currentUser && currentUser?.role === "root" && (
                  <>
                    {driver?.paymentmode === "BRANCH" ? (
                      <div div className="form__col form__col_full-width deposit">
                        <div className="section section_group">
                          <h3 className="section__title">Deposit (BRANCH):</h3>
                          <ul className="brief brief_null" style={{ paddingTop: "0" }}>
                            <li className="brief__item brief__item_has-been convicted">
                              <span className="brief__item-cell brief__item-cell_title">Account Number:</span>
                              <span>{maskingInfo(driver.depositAccountNumber) || ""}</span>
                            </li>
                            <li className="brief__item brief__item_has-been convicted">
                              <span className="brief__item-cell brief__item-cell_title">Routing Number:</span>
                              <span>{maskingInfo(driver.depositRoutingNumber) || ""}</span>
                            </li>

                            <li className="brief__item brief__item_has-been convicted">
                              <span className="brief__item-cell brief__item-cell_title">Branch Status:</span>
                              <p style={{ textTransform: "capitalize" }}>{driver?.branch?.status || "-"}</p>
                            </li>
                          </ul>

                          {driver?.branch?.status !== "ACTIVE" && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: rdbLoading ? "#4195f560" : "#4195f5",
                                width: "15%",
                                height: "35px",
                                borderRadius: "8px",
                                padding: "10px",
                                color: "#fff",
                                cursor: rdbLoading ? "not-allowed" : "pointer"
                              }}
                              onClick={!rdbLoading ? handleRefreshBranch : undefined}
                             >
                              {
                                rdbLoading ? <CircularProgress size={24} style={{ color: "#fff" }} /> : "Refresh Branch"
                              }
                              </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div div className="form__col form__col_full-width deposit">
                        <div className="section section_group">
                          <h3 className="section__title">Deposit (DWOLLA):</h3>
                          <div className="form__row">
                            <div className="form__col form__col_height-flex">
                              <div className="section">
                                <div className="section__title">Customer:</div>

                                <form onSubmit={customerForm.handleSubmit(createOrUpdateCustomer)}>
                                  <InputItem
                                    name="depositHolderName"
                                    initialValue={driver.depositHolderName}
                                    title="First Name"
                                    form={customerForm}
                                  />
                                  <InputItem
                                    name="depositHolderSurname"
                                    initialValue={driver.depositHolderSurname}
                                    title="Last Name"
                                    form={customerForm}
                                  />
                                  <InputItem
                                    name="depositHolderEmail"
                                    initialValue={driver.depositHolderEmail}
                                    title="Email"
                                    form={customerForm}
                                  />

                                  <div className="form__item form__item_deposit">
                                    <input
                                      type="hidden"
                                      {...customerForm.register("_id", {
                                        value: driver._id,
                                      })}
                                    />
                                    <button className="btn btn_accent btn_block" type="submit">
                                      Create Customer
                                    </button>
                                    {driver && !driver?.dwCustomerUrl && (
                                      <div className={`form__msg form__msg_invalid ${!driver?.dwCustomerUrl ? "form__msg_visible" : ""}`}>
                                        <span>Customer is not created in dwolla</span>
                                      </div>
                                    )}
                                  </div>

                                  <div>{JSON.stringify(createOrUpdateCustomerReq.data)}</div>
                                </form>
                              </div>
                            </div>

                            <div className="form__col form__col_height-flex" style={{ paddingBottom: "0px" }}>
                              <div className="section">
                                <div className="section__title">Funding Source:</div>

                                <form onSubmit={fundingSourceForm.handleSubmit(createOrUpdateFundingSource)}>
                                  <InputItem
                                    name="depositAccountNumber"
                                    initialValue={maskingInfo(driver.depositAccountNumber)}
                                    title="Account Number"
                                    form={fundingSourceForm}
                                  />
                                  <InputItem
                                    name="depositRoutingNumber"
                                    initialValue={maskingInfo(driver.depositRoutingNumber)}
                                    title="Routing Number"
                                    form={fundingSourceForm}
                                  />

                                  <div className="form__item">
                                    <label className="form__label">Type:</label>

                                    <div className="form__input-place">
                                      <div className="form__inline-items form__inline-items_deposit">
                                        <label htmlFor="deposit_type_checking" className="form__check-label">
                                          <input
                                            type="radio"
                                            name="deposit_type"
                                            id="deposit_type_checking"
                                            value="checking"
                                            {...fundingSourceForm.register("depositType", { value: driver.depositType })}
                                          />
                                          Checking
                                        </label>
                                        <label htmlFor="deposit_type_saving" className="form__check-label">
                                          <input
                                            type="radio"
                                            name="deposit_type"
                                            id="deposit_type_saving"
                                            value="savings"
                                            {...fundingSourceForm.register("depositType", { value: driver.depositType })}
                                          />
                                          Saving
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorMessage />
                                  </div>

                                  <div className="form__item form__item_deposit">
                                    <input
                                      type="hidden"
                                      {...fundingSourceForm.register("_id", {
                                        value: driver._id,
                                      })}
                                    />
                                    <button className="btn btn_accent btn_block" type="submit">
                                      Create Funding Source
                                    </button>
                                    {driver && !driver?.dwFundingSourceUrl && (
                                      <div
                                        className={`form__msg form__msg_invalid ${!driver?.dwFundingSourceUrl ? "form__msg_visible" : ""}`}
                                      >
                                        <span>Funding source is not created in dwolla</span>
                                      </div>
                                    )}
                                  </div>

                                  <div>{JSON.stringify(createOrUpdateFundingSourceReq.data)}</div>
                                </form>
                              </div>
                            </div>
                          </div>

                          {driver?.branch?.status !== "ACTIVE" && (
                           <div 
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: rdbLoading ? "#4195f560" : "#4195f5",
                                width: "15%",
                                height: "35px",
                                borderRadius: "8px",
                                padding: "10px",
                                color: "#fff",
                                cursor: rdbLoading ? "not-allowed" : "pointer"
                              }}
                              onClick={!rdbLoading ? handleRefreshBranch : undefined}
                             >
                              {
                                rdbLoading ? <CircularProgress size={24} style={{ color: "#fff" }} /> : "Refresh Branch"
                              }
                              </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                <History id={id} transitionHistoryData={transitionHistoryData?.result} />

                <div className="form__col form__col_full-width">
                  <div className="section">
                    <ul className="brief brief_summary">
                      <li className="brief__item">
                        <span className="brief__item-cell brief__item-cell_title">Wages Earned:</span>
                        <span className="brief__item-cell brief__item-cell_value">${driver?.wallet?.toFixed(2)}</span>
                      </li>
                      <li className="brief__item">
                        <span className="brief__item-cell brief__item-cell_title">Referral Earned:</span>
                        <span className="brief__item-cell brief__item-cell_value">
                          ${(driver?.bonus?.referral_earning || 0)?.toFixed(2)}
                        </span>
                      </li>
                      <li className="brief__item">
                        <span className="brief__item-cell brief__item-cell_title">Total Invited:</span>
                        <span className="brief__item-cell brief__item-cell_value">{driver?.bonus?.referrals?.length || 0}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div className="loading-wrapper">
                <CircularProgress />
              </div>
            )}
          </div>
          {driver?.status !== "rejected" && (
            <div className="modal__footer">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <div>
                  {(checkForApproveOrReject || driver?.status === "under_review") && (
                    <button
                      className="btn btn_reject"
                      style={{ border: "1px solid #FA6757", color: "#FA6757", padding: "0.688rem 1.563rem", fontSize: "1rem" }}
                      onClick={() => {
                        actions.modal.openReason({
                          obj: driver,
                          title: "REJECT__DRIVER",
                        });
                      }}
                    >
                      Reject
                    </button>
                  )}
                </div>
                <div>
                  {driver?.status === "approved" || (driver?.isInsuranceReview && driver?.isLicenseReview && driver?.isSelfieReview && driver?.isSignatureReview) ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {(checkForApproveOrReject || driver?.status === "under_review") && (
                        <div style={{ position: "relative" }}>
                          {approveDriverReq.isLoading && (
                            <CircularProgress
                              size={18}
                              sx={{
                                color: "#fff",
                                position: "absolute",
                                top: "50%",
                                left: "83%",
                                marginTop: "-8px",
                                marginLeft: "-10px",
                              }}
                            />
                          )}
                          <button
                            className={cn("btn btn_accent", {
                              btn_disabled: approveDriverReq.isLoading || (driver?.status === "not_approved" && driver?.isWaitingActive),
                            })}
                            disabled={driver?.status === "not_approved" && driver?.isWaitingActive}
                            onClick={async () => {
                              setShowApproveConfirmation(true);
                            }}
                          >
                            {!approveDriverReq.isLoading ? <FaCheck className="btn__icon" /> : <div style={{ width: "25%" }}></div>}
                            Approve
                          </button>
                        </div>
                      )}
                      {checkForActivateDrivers && (
                        <div style={{ position: "relative" }}>
                          {approveDriverReq.isLoading && (
                            <CircularProgress
                              size={18}
                              sx={{
                                color: "#fff",
                                position: "absolute",
                                top: "50%",
                                left: "25%",
                                marginTop: "-8px",
                                marginLeft: "-10px",
                                zIndex: "9",
                              }}
                            />
                          )}
                          <button
                            className={cn("btn btn_accent", {
                              btn_disabled: approveDriverReq.isLoading,
                            })}
                            onClick={async () => {
                              const result = await approveDriver({ _id: driver._id });
                              handleStatus(result, "approved", "driver active successfully");
                            }}
                          >
                            {!approveDriverReq.isLoading ? <FaCheck className="btn__icon" /> : <div style={{ width: "25%" }}></div>}
                            Active
                          </button>
                        </div>
                      )}
                      {checkForOffBoardDriver && (
                        <button
                          className={cn("btn btn_reject")}
                          onClick={() => {
                            actions.modal.openReason({
                              obj: driver,
                              title: "OFF__BOARD__DRIVER",
                            });
                          }}
                        >
                          Offboard
                        </button>
                      )}

                      {checkForOnBoardDriver && (
                        <div style={{ position: "relative" }}>
                          <button
                            className={cn("btn btn_accent", {
                              btn_disabled: approveDriverReq?.isLoading,
                            })}
                            onClick={async () => {
                              const result = await approveDriver({ _id: driver._id });
                              handleStatus(result, "onboard");
                            }}
                          >
                            Onboard
                            {approveDriverReq?.isLoading && <div style={{ width: "25px" }}></div>}
                          </button>
                          {approveDriverReq?.isLoading && (
                            <CircularProgress
                              size={18}
                              sx={{
                                color: "#fff",
                                position: "absolute",
                                top: "50%",
                                left: "83%",
                                marginTop: "-8px",
                                marginLeft: "-10px",
                              }}
                            />
                          )}
                        </div>
                      )}

                      {checkForMakingDriverInactive && (
                        <button
                          className={cn("btn btn_reject")}
                          onClick={() => {
                            actions.modal.openReason({
                              obj: driver,
                              title: "INACTIVE__DRIVER",
                            });
                          }}
                        >
                          Inactive
                        </button>
                      )}

                      {/* {checkForWaitingList && (
                      <button
                        className="btn"
                        onClick={() => {
                          setShowConfirmation(true);
                        }}
                      >
                        Waiting List
                      </button>
                    )} */}

                      {(checkForApproveOrReject || driver?.status === "submitted") && (
                        <button
                          className="btn"
                          onClick={() => {
                            setShowModalOfUr(true);
                          }}
                        >
                          Under Review
                        </button>
                      )}

                      {driver?.status === "approved" && (
                        <button
                          className="btn"
                          style={{ border: "1px solid #f6a800", color: "#f6a800" }}
                          onClick={() => {
                            setSuspendConfirmation(true);
                          }}
                        >
                          Suspend
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="confirmation_btn">
                      <Button
                        variant="outlined"
                        className="confirmation_btn__cancel"
                        onClick={() => {
                          handleGetReason();
                          setDocumentApproval({
                            selfieApproval: false,
                            licenceApproval: false,
                            insuranceApproval: false,
                          });
                          setUnapproveOverride({
                            selfieApproval: false,
                            licenceApproval: false,
                            insuranceApproval: false,
                            signatureApproval: false,
                          });
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        className="confirmation_btn__save"
                        disabled={
                          ((driver?.isSelfieReview && !unapproveOverride.selfieApproval) || !selectedSelfieReason.length || arraysAreEqual(selectedSelfieReason, selfieReaosn)) &&
                          ((driver?.isInsuranceReview && !unapproveOverride.insuranceApproval) ||
                            !selectedInsuranceReason.length ||
                            arraysAreEqual(selectedInsuranceReason, insuranceReaosn)) &&
                          ((driver?.isLicenseReview && !unapproveOverride.licenceApproval) || !selectedReason.length || arraysAreEqual(selectedReason, driverReaosn)) &&
                          ((driver?.isSignatureReview && !unapproveOverride.signatureApproval) || !selectedSignatureReason?.length || arraysAreEqual(selectedSignatureReason, signatureReaosn))
                        }
                        onClick={() => handleReviewDocument()}
                      >
                        {docRLoading ? (
                          <CircularProgress
                            size={24}
                            sx={{
                              color: "#fff",
                            }}
                          />
                        ) : (
                          "Save"
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </div>

              {/* <button className="btn btn_accent" onClick={() => actions.modal.closeDriver()}>
              Close
            </button> */}
            </div>
          )}
        </div>
      </Modal>

      {showMur && (
        <ConfirmDialogModal
          title={`Enter "Mark Under Review" reason`}
          bodyText={
            <textarea
              value={murReason || driver?.underReview?.reason || ""}
              onChange={(e) => setMurReason(e.target.value)}
              style={{
                resize: "none",
                overflow: "auto",
                width: "100%",
                borderRadius: "10px",
                padding: "8px 15px",
              }}
              rows="3"
            />
          }
          isOpen
          onClose={() => {
            setMurReason(driver?.underReview?.reason || "");
            setShowMur(false);
          }}
          confirmAction={handleUnderReview}
          modalText="CANCEL__SHIFT"
          isLoading={murLoading}
          isRejectingShift={false}
          isDisabled={!murReason}
        />
      )}

      {showModalOfUr && (
        <ConfirmDialogModal
          title={`Enter Mark Under Review`}
          bodyText="Are you sure you want to move this driver under review?"
          isOpen
          onClose={() => {
            setShowModalOfUr(false);
          }}
          confirmAction={handlStatuseUnderReview}
          modalText="CANCEL__SHIFT"
          isLoading={msurLoading}
          isRejectingShift={false}
        />
      )}

      {murdeleteConf && (
        <ConfirmDialogModal
          title="Remove from Under Review Confirmation"
          bodyText="Are you sure you want to remove this driver from under review?"
          isOpen
          isLoading={removeReviewLoading}
          confirmAction={handleRemoveUnderReview}
          onClose={() => setMurdeleteConf(false)}
        />
      )}

      {suspendConfirmation && (
        <ConfirmDialogModal
          grayDisabled
          title="Choose a reason and date for the suspension"
          bodyText={
            <SuspensionForm
              reasons={reasonData.suspensionReasonData || []}
              reasonLoading={reasonLoading}
              onSuspensionDataChange={handleSuspensionDataChange}
              underReviewReason={driverData?.underReview?.reason}
            />
          }
          isOpen
          isLoading={SuspendLoading}
          confirmAction={handleSuspension}
          onClose={() => {
            setSuspensionData({
              category: "",
              group: "",
              reasonId: "",
              reasonText: "",
              severity: "",
              underReviewReason: "",
              suspensionDays: 0,
              suspensionDate: new Date(),
            });
            setSuspendConfirmation(false);
          }}
          isDisabled={!suspensionData.reasonId || !suspensionData.severity}
        />
      )}

      {showDialog && (
        <ConfirmDialogModal
          title="Delete Occupational Accident Insurance"
          bodyText="Are you sure you want to delete?"
          isOpen
          isLoading={updateReq.isLoading}
          confirmAction={handleDelete}
          onClose={() => setShowDialog(false)}
        />
      )}

      {showConfirmation && (
        <ConfirmDialogModal
          title="Waiting List"
          bodyText="Are you sure you want to add to waiting list?"
          isOpen
          isLoading={waitingListDriverReq.isLoading}
          confirmAction={handleWaitingList}
          onClose={() => setShowConfirmation(false)}
        />
      )}

      {showApproveConfirmation && (
        <Modal
          open={showApproveConfirmation}
          onClose={() => setShowApproveConfirmation(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modal modal_dialog" style={{ height: "auto" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10 }}>
              <h2 style={{ flex: 1, color: "#000", fontSize: "1.1rem", fontWeight: 600, marginBottom: 0 }}>This is an approve driver</h2>
              <ClearIcon style={{ cursor: "pointer" }} onClick={() => setShowApproveConfirmation(false)} />
            </div>

            <div>
              <div style={{ fontWeight: 700, marginBottom: 3, fontSize: "1.05rem" }}>Select one of the following options:</div>
              <RadioGroup value={selecteApproveOption} onChange={(e) => setSelecteApproveOption(e.target.value)}>
                {aprroveReasonList.map((item) => (
                  <FormControlLabel
                    key={item.value}
                    value={item.value}
                    control={<Radio size="small" />}
                    label={item.lable}
                    style={{ marginBottom: 0 }}
                  />
                ))}
              </RadioGroup>
            </div>

            <div className="modal__footer" style={{ borderTop: "1px solid #dadada" }}>
              <button
                className="btn btn_accent"
                disabled={!selecteApproveOption || approveDriverReq.isLoading || waitingListDriverReq.isLoading}
                onClick={() => handleApproveDriver()}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}
      
      {showConApproveConfirmation && (
        <ConfirmDialogModal
          title={`Conditionally Approved`}
          bodyText={`Are you sure you want to conditionally approve this drive? The driver branch setup has not been fully completed yet.`}
          isOpen
          isLoading={approveDriverReq.isLoading}
          confirmAction={handleConditionallyApproved}
          onClose={() => {
            setShowConApproveConfirmation("");
          }}
        />
      )}
    </React.Fragment>
  );
};

export default CustomModal;
